const EVT_CHILD_CHANGE = 'child.change'
const EVT_CHILD_REMOVE = 'child.remove'

export default {
  EVT_CHILD_CHANGE,
  EVT_CHILD_REMOVE
}
